import { Controller } from "stimulus"

const ORDER_KEY = "clientLedgerOrder"
const BY_DATE   = "date"

export default class extends Controller {
  static targets = [ "rows", "dateHeader", "groupedIcon", "byDateIcon" ]

  connect() {
    if (this.storedOrder() === BY_DATE) this.apply(BY_DATE)
  }

  toggleOrder() {
    const order = this.order === BY_DATE ? "grouped" : BY_DATE
    this.apply(order)

    try { localStorage.setItem(ORDER_KEY, order) } catch (e) {}
  }

  apply(order) {
    this.order = order

    const byDate = order === BY_DATE
    const rows   = Array.from(this.rowsTarget.querySelectorAll(".ledger-row"))
    const index  = row => Number(byDate ? row.dataset.dateIndex : row.dataset.groupedIndex)

    rows.sort((a, b) => index(a) - index(b)).forEach(row => {
      row.querySelector("[data-ledger-balance]").textContent =
        byDate ? row.dataset.dateBalance : row.dataset.groupedBalance
      this.rowsTarget.appendChild(row)
    })

    this.groupedIconTarget.hidden = byDate
    this.byDateIconTarget.hidden  = !byDate
    this.dateHeaderTarget.classList.toggle("ledger-sortable--active", byDate)
    this.dateHeaderTarget.title = byDate ? this.dateHeaderTarget.dataset.byInvoiceTitle
                                         : this.dateHeaderTarget.dataset.byDateTitle
  }

  storedOrder() {
    try { return localStorage.getItem(ORDER_KEY) } catch (e) { return null }
  }

  highlight(event) {
    this.link(event.currentTarget, true)
  }

  clear(event) {
    this.link(event.currentTarget, false)
  }

  link(row, linked) {
    const invoiceId = row.dataset.invoiceId
    if (!invoiceId) return

    this.rowsTarget
      .querySelectorAll(`.ledger-row[data-invoice-id="${invoiceId}"]`)
      .forEach(other => other.classList.toggle("ledger-row--linked", linked))
  }
}
